import React, {Component} from 'react';
import {Button, Col, Container, FormGroup, Input, InputGroup, InputGroupAddon, Label, Alert, UncontrolledTooltip} from "reactstrap";
import AppActions from './../actions/AppActions';
import connection from './../lib/connection';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";

export class Home extends Component {
    componentDidMount() {
        setTimeout(() => {
            AppActions.updateStates([
                {statePath: 'apiKey', data: window.localStorage.getItem('apiKey') || ''},
                {statePath: 'mixId', data: window.localStorage.getItem('mixId') || ''},
                {statePath: 'groupName', data: window.localStorage.getItem('groupName') || ''}
            ]);
        }, 0);
    }

    setVisibility(visibility) {
        AppActions.updateState("visibility", !visibility);
    }

    updateStateAndLocalStorage(key, value) {
        AppActions.updateState(key, value);
        window.localStorage.setItem(key, value);
    }

    render() {
        const {apiKey, mixId, groupName, connectionError, connected, joined, visibility=true} = this.props;

        return (
            <Container>
                <h1>Digital Twin Portal</h1>

                <FormGroup row>
                    <Label for="apiKey" sm={2}>Api-Key</Label>
                    <Col sm={10}>
                        <InputGroup>
                            <Input
                                type={visibility ? "text" : "password"}
                                id="apiKey"
                                value={apiKey || ''}
                                onChange={(event) => this.updateStateAndLocalStorage('apiKey', event.target.value)} />
                            <InputGroupAddon addonType="append">
                                <Button
                                    id="visibility"
                                    onClick={() => {
                                        this.setVisibility(visibility);
                                    }}
                                >
                                    {visibility ? (
                                    <FontAwesomeIcon icon={faEyeSlash} />
                                    ) : (
                                    <FontAwesomeIcon icon={faEye} />
                                    )}
                                </Button>
                                <UncontrolledTooltip placement="top" target="visibility">
                                    {visibility ? "Hide": "Show"}
                                </UncontrolledTooltip>
                            </InputGroupAddon>
                        </InputGroup>
                    </Col>                        
                </FormGroup>
                <FormGroup row>
                    <Label for="mixId" sm={2}>Mix id</Label>
                    <Col sm={10}>
                        <Input
                            type="text"
                            id="mixId"
                            value={mixId || ''}
                            onChange={(event) => this.updateStateAndLocalStorage('mixId', event.target.value)}/>
                    </Col>
                </FormGroup>

                <FormGroup row>
                    <Label for="groupName" sm={2}>Live data group name</Label>
                    <Col sm={10}>
                        <Input
                            type="text"
                            id="groupName"
                            value={groupName || ''}
                            onChange={(event) => this.updateStateAndLocalStorage('groupName', event.target.value)}/>
                    </Col>
                </FormGroup>
                {connectionError && <Alert color="danger">{connectionError}</Alert>}
                {connected && <Alert color="success">Connected</Alert>}
                {joined && <Alert color="success">Joined {joined}</Alert>}
                {connected && joined !== groupName && <Button onClick={() => this.joinGroup()}>Join group</Button>}
            </Container>
        );
    }

    joinGroup() {
        const {mixId, groupName} = this.props;

        connection.invoke("Join", mixId, groupName);

        AppActions.updateState('joined', groupName);
    }
}